/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * MyYoast
 * The MyYoast Api
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CurrentVersionParams,
  CurrentVersionV2Params,
  CurrentZipParams,
  ProductVersionsDto
} from '../models';

import { customFetch } from '../../customFetch';
import type { ErrorType } from '../../customFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getCurrentVersionUrl = (params: CurrentVersionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provisioning/downloads/currentVersion?${stringifiedParams}` : `/api/provisioning/downloads/currentVersion`
}

/**
 * This route returns the latest version of the product that is offered to the customer when using the passed productCode.
 * @deprecated
 * @summary Retrieve the current version for the productCode for the provisioner.
 */
export const currentVersion = async (params: CurrentVersionParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getCurrentVersionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCurrentVersionQueryKey = (params?: CurrentVersionParams,) => {
    return [
    `/api/provisioning/downloads/currentVersion`, ...(params ? [params] : [])
    ] as const;
    }


export const getCurrentVersionQueryOptions = <TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(params: CurrentVersionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentVersionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentVersion>>> = ({ signal }) => currentVersion(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentVersionQueryResult = NonNullable<Awaited<ReturnType<typeof currentVersion>>>
export type CurrentVersionQueryError = ErrorType<void>


export function useCurrentVersion<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentVersion>>,
          TError,
          Awaited<ReturnType<typeof currentVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersion<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentVersion>>,
          TError,
          Awaited<ReturnType<typeof currentVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersion<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Retrieve the current version for the productCode for the provisioner.
 */

export function useCurrentVersion<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentVersionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentVersionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(params: CurrentVersionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentVersionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentVersion>>> = ({ signal }) => currentVersion(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentVersionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof currentVersion>>>
export type CurrentVersionSuspenseQueryError = ErrorType<void>


export function useCurrentVersionSuspense<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersionSuspense<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersionSuspense<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Retrieve the current version for the productCode for the provisioner.
 */

export function useCurrentVersionSuspense<TData = Awaited<ReturnType<typeof currentVersion>>, TError = ErrorType<void>>(
 params: CurrentVersionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentVersionSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentVersionV2Url = (params: CurrentVersionV2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v2/provisioning/downloads/currentVersion?${stringifiedParams}` : `/api/v2/provisioning/downloads/currentVersion`
}

/**
 * This route returns the version numbers and the download URLs of the latest versions of the available downloads for a product
 * @summary Get current version of downloads for a product.
 */
export const currentVersionV2 = async (params: CurrentVersionV2Params, options?: RequestInit): Promise<ProductVersionsDto> => {

  return customFetch<ProductVersionsDto>(getCurrentVersionV2Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCurrentVersionV2QueryKey = (params?: CurrentVersionV2Params,) => {
    return [
    `/api/v2/provisioning/downloads/currentVersion`, ...(params ? [params] : [])
    ] as const;
    }


export const getCurrentVersionV2QueryOptions = <TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(params: CurrentVersionV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentVersionV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentVersionV2>>> = ({ signal }) => currentVersionV2(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentVersionV2QueryResult = NonNullable<Awaited<ReturnType<typeof currentVersionV2>>>
export type CurrentVersionV2QueryError = ErrorType<void>


export function useCurrentVersionV2<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentVersionV2>>,
          TError,
          Awaited<ReturnType<typeof currentVersionV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersionV2<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentVersionV2>>,
          TError,
          Awaited<ReturnType<typeof currentVersionV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersionV2<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current version of downloads for a product.
 */

export function useCurrentVersionV2<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentVersionV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentVersionV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(params: CurrentVersionV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentVersionV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentVersionV2>>> = ({ signal }) => currentVersionV2(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentVersionV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof currentVersionV2>>>
export type CurrentVersionV2SuspenseQueryError = ErrorType<void>


export function useCurrentVersionV2Suspense<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersionV2Suspense<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentVersionV2Suspense<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current version of downloads for a product.
 */

export function useCurrentVersionV2Suspense<TData = Awaited<ReturnType<typeof currentVersionV2>>, TError = ErrorType<void>>(
 params: CurrentVersionV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentVersionV2>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentVersionV2SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentZipUrl = (params: CurrentZipParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provisioning/downloads/currentZip?${stringifiedParams}` : `/api/provisioning/downloads/currentZip`
}

/**
 * If a new version is available, you can use this route to redirect to the zip of that new version of the product.
 * @deprecated
 * @summary Redirect to the current zip for the productCode.
 */
export const currentZip = async (params: CurrentZipParams, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getCurrentZipUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCurrentZipQueryKey = (params?: CurrentZipParams,) => {
    return [
    `/api/provisioning/downloads/currentZip`, ...(params ? [params] : [])
    ] as const;
    }


export const getCurrentZipQueryOptions = <TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(params: CurrentZipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentZipQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentZip>>> = ({ signal }) => currentZip(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentZipQueryResult = NonNullable<Awaited<ReturnType<typeof currentZip>>>
export type CurrentZipQueryError = ErrorType<void>


export function useCurrentZip<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentZip>>,
          TError,
          Awaited<ReturnType<typeof currentZip>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentZip<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentZip>>,
          TError,
          Awaited<ReturnType<typeof currentZip>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentZip<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Redirect to the current zip for the productCode.
 */

export function useCurrentZip<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentZipQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentZipSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(params: CurrentZipParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentZipQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentZip>>> = ({ signal }) => currentZip(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentZipSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof currentZip>>>
export type CurrentZipSuspenseQueryError = ErrorType<void>


export function useCurrentZipSuspense<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentZipSuspense<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentZipSuspense<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Redirect to the current zip for the productCode.
 */

export function useCurrentZipSuspense<TData = Awaited<ReturnType<typeof currentZip>>, TError = ErrorType<void>>(
 params: CurrentZipParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentZip>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentZipSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






